import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import NavBar from '../../components/NavBar';
import store from 'store2';

export default class List extends Component {

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={__URLPREFIX__ + '/trainer/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'name',
				title: 'Jméno',
				field: 'name',
				renderer: rendererLink
			},
			{
				name: 'surname',
				title: 'Příjmení',
				field: 'surname',
				renderer: rendererLink
			},
			{
				name: 'active',
				title: 'Aktivní',
				field: 'active',
				width: 60,
				align: 'center',
				viewport: 'tablet',
				renderer: Renderers.coloredCheck
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={__URLPREFIX__ + '/trainer/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i><span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			id: { class: FilterInput },
			name: { class: FilterInput },
			surname: { class: FilterInput },
			active: {class:  Select, options: [{id: '1', title: 'Ano'},{id: '0', title:'Ne'}], placeholder: '---'},
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-trainer');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'surname', 'direction': 'asc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('trainer.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('trainer.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('trainer', row.title, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={__URLPREFIX__ + "/trainer/0"} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový školitel
		</Button>;


		return (
			<div>
				<NavBar title="Školitelé" buttons={[{icon: 'fa fa-refresh', onClick: () => this.refs.datagrid.getWrappedInstance().refresh()},{icon: 'fa fa-plus', onClick: () => this.props.newTab()}]} />
				<Datagrid
					ref="datagrid"
					id="trainer"
					api="trainer.getList"
					buttons={buttons}
					filters={['fulltext']}
					filter={this.filter}
					saveState={true}
					columnModel={this.columnModel}
					defaultFilter={this.defaultFilter}
					defaultSort={this.defaultSort}
				/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Trainer/List.js